<script setup>

import KdAccountUnitAnalystAudit from "./kdAccountUnitAnalystAudit.vue";
import KdAccountUnitUploadInventoryHandStatusAudit from "./kdAccountUnitUploadInventoryHandStatusAudit.vue";
import KdAccountUnitWriteFinishStatusAudit from "./kdAccountUnitWriteFinishStatusAudit.vue";
import KdAccountUnitWritePermanentSolutionAudit from "./kdAccountUnitWritePermanentSolutionAudit.vue";
import KdMarketEngineerAudit from "./kdMarketEngineerAudit.vue";
import KdMarketingManagerAudit from "./kdMarketingManagerAudit.vue";
import KdNormalAudit from "./kdNormalAudit.vue";
import KdQeAssignAccountUnitAudit from "./kdQeAssignAccountUnitAudit.vue";
import KdQeCheckAndUploadBreakPointInfoAudit from "./kdQeCheckAndUploadBreakPointInfoAudit.vue";
import KdQeEnsurePermanentSolutionAudit from "./kdQeEnsurePermanentSolutionAudit.vue";
import KdQeReasonAnalystAudit from "./kdQeReasonAnalystAudit.vue";
import KdQeVehicleDisposalPlanForTheOutputMarketAudit from "./kdQeVehicleDisposalPlanForTheOutputMarketAudit.vue";
import KdQualityEngineerCloseAudit from "./kdQualityEngineerCloseAudit.vue";
import KdQualityManagerInitiateRecallAudit from "./kdQualityManagerInitiateRecallAudit.vue";
import KdQualityReasonAnalystAudit from "./kdQualityReasonAnalystAudit.vue";
import KdReasonAnalystAudit from "./kdReasonAnalystAudit.vue";
import KdSolutionAudit from "./kdSolutionAudit.vue";
import KdQualityManagerUpgradeAudit from "./kdQualityManagerUpgradeAudit.vue";
</script>

<template>
    <div class="audit-form-main">
      <el-tabs v-model="activeName">
        <el-tab-pane label="accountUnitAnalystAudit" name="accountUnitAnalystAudit">
          <kd-account-unit-analyst-audit  :taskId="taskId"></kd-account-unit-analyst-audit>
        </el-tab-pane>
        <el-tab-pane label="accountUnitUploadInventoryHandStatusAudit" name="accountUnitUploadInventoryHandStatusAudit">
          <kd-account-unit-upload-inventory-hand-status-audit :taskId="taskId"></kd-account-unit-upload-inventory-hand-status-audit>

        </el-tab-pane>
        <el-tab-pane label="accountUnitWriteFinishStatusAudit" name="accountUnitWriteFinishStatusAudit">
          <kd-account-unit-write-finish-status-audit :taskId="taskId"></kd-account-unit-write-finish-status-audit>

        </el-tab-pane>
        <el-tab-pane label="accountUnitWritePermanentSolutionAudit" name="accountUnitWritePermanentSolutionAudit">
          <kd-account-unit-write-permanent-solution-audit :taskId="taskId"></kd-account-unit-write-permanent-solution-audit>

        </el-tab-pane>
        <el-tab-pane label="marketEngineerAudit" name="marketEngineerAudit">
          <kd-market-engineer-audit :taskId="taskId"></kd-market-engineer-audit>

        </el-tab-pane>
        <el-tab-pane label="marketingManagerAudit" name="marketingManagerAudit">
          <kd-marketing-manager-audit :taskId="taskId"></kd-marketing-manager-audit>
        </el-tab-pane>
        <el-tab-pane label="normalAudit" name="normalAudit">
          <kd-normal-audit :taskId="taskId"></kd-normal-audit>
        </el-tab-pane>
        <el-tab-pane label="qeAssignAccountUnitAudit" name="qeAssignAccountUnitAudit">
          <kd-qe-assign-account-unit-audit :taskId="taskId"></kd-qe-assign-account-unit-audit>

        </el-tab-pane>
        <el-tab-pane label="qeCheckAndUploadBreakPointInfoAudit" name="qeCheckAndUploadBreakPointInfoAudit">
          <kd-qe-check-and-upload-break-point-info-audit :taskId="taskId"></kd-qe-check-and-upload-break-point-info-audit>

        </el-tab-pane>
        <el-tab-pane label="qeEnsurePermanentSolutionAudit" name="qeEnsurePermanentSolutionAudit">
          <kd-qe-ensure-permanent-solution-audit :taskId="taskId"></kd-qe-ensure-permanent-solution-audit>

        </el-tab-pane>
        <el-tab-pane label="qeReasonAnalystAudit" name="qeReasonAnalystAudit">
          <kd-qe-reason-analyst-audit :taskId="taskId"></kd-qe-reason-analyst-audit>

        </el-tab-pane>
        <el-tab-pane label="qeVehicleDisposalPlanForTheOutputMarketAudit" name="qeVehicleDisposalPlanForTheOutputMarketAudit">
          <kd-qe-vehicle-disposal-plan-for-the-output-market-audit :taskId="taskId"></kd-qe-vehicle-disposal-plan-for-the-output-market-audit>

        </el-tab-pane>
        <el-tab-pane label="qualityEngineerCloseAudit" name="qualityEngineerCloseAudit">
          <kd-quality-engineer-close-audit :taskId="taskId"></kd-quality-engineer-close-audit>

        </el-tab-pane>
        <el-tab-pane label="qualityManagerInitiateRecallAudit" name="qualityManagerInitiateRecallAudit">
          <kd-quality-manager-initiate-recall-audit :taskId="taskId"></kd-quality-manager-initiate-recall-audit>

        </el-tab-pane>
        <el-tab-pane label="qualityReasonAnalystAudit" name="qualityReasonAnalystAudit">
          <kd-quality-reason-analyst-audit :taskId="taskId" ></kd-quality-reason-analyst-audit>
        </el-tab-pane>
        <el-tab-pane label="reasonAnalystAudit" name="reasonAnalystAudit">
          <kd-reason-analyst-audit :taskId="taskId"></kd-reason-analyst-audit>
        </el-tab-pane>
        <el-tab-pane label="solutionAudit" name="solutionAudit">
          <kd-solution-audit :taskId="taskId"></kd-solution-audit>
        </el-tab-pane>
        <el-tab-pane label="qualityManagerUpgradeAudit" name="qualityManagerUpgradeAudit">
          <kd-quality-manager-upgrade-audit :taskId="taskId"></kd-quality-manager-upgrade-audit>
        </el-tab-pane>
      </el-tabs>



    </div>
</template>

<style scoped lang="scss">

</style>
<script>
export default {
  name: "testTab",
  props: {
    taskId: {
      type: String,
      default: ""
    },
    auditType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      activeName:"accountUnitAnalystAudit"
    }
  },
  components: {
  },
  methods: {

  }
}
</script>
